module.exports = __webpack_public_path__ + "static/media/fitness-2.dfd50dfd.png";